// Generated from Figma tokens. Do not edit directly.

export const componentTokens = {
  Input: {
    paddingInlineSM: 7,
    paddingInlineLG: 11,
    paddingInline: 11,
    paddingBlockSM: 0,
    paddingBlockLG: 7,
    paddingBlock: 4,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorWarningBorderHover: "#ffd666",
    colorWarning: "#faad14",
    colorTextTertiary: "rgba(0, 0, 0, 0.7)",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimary: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorErrorBorderHover: "#ffa39e",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    hoverBorderColor: "#4439a3",
    addonBg: "rgba(0, 0, 0, 0.02)",
    activeBorderColor: "#0d058f",
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorFillSecondary: "#f6f4ff",
    colorErrorBgHover: "#fff1f0",
    colorErrorBg: "#fff2f0",
    colorWarningBg: "#fff8d4",
    colorWarningBgHover: "#fff1b8",
    colorWarningText: "#b05800",
    colorErrorText: "#ff4d4f",
    activeBg: "#ffffff",
    hoverBg: "#ffffff",
    inputFontSize: 14,
    inputFontSizeLG: 16,
    inputFontSizeSM: 12,
    fontFamily: "space grotesk",
  },
  Transfer: {
    listWidthLG: 250,
    listWidth: 180,
    listHeight: 200,
    itemPaddingBlock: 5,
    paddingXS: 8,
    paddingSM: 12,
    marginXXS: 4,
    marginXS: 8,
    margin: 16,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeIcon: 12,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActiveHover: "#e4e1ed",
    controlItemBgActive: "#eeedf6",
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusLG: 4,
    colorWarning: "#faad14",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorLinkHover: "#4439a3",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    itemHeight: 32,
    headerHeight: 40,
    fontFamily: "space grotesk",
  },
  Segmented: {
    segmentedBgColorSelected: "#ffffff",
    paddingXXS: 4,
    marginSM: 12,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorTextLabel: "rgba(0, 0, 0, 0.65)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorFillSecondary: "#f6f4ff",
    colorFill: "#f7f4f1",
    colorBgLayout: "#f2ece6",
    colorBgElevated: "#ffffff",
    segmentedGroupBg: "rgba(0, 0, 0, 0.04)",
    itemSelectedColor: "rgba(0, 0, 0, 0.88)",
    itemSelectedBg: "#ffffff",
    itemHoverColor: "rgba(0, 0, 0, 0.88)",
    itemHoverBg: "#f6f4ff",
    itemColor: "rgba(0, 0, 0, 0.65)",
    itemActiveBg: "#f7f4f1",
    trackPadding: 2,
    trackBg: "#f2ece6",
    fontFamily: "space grotesk",
  },
  Switch: {
    trackPadding: 2,
    trackMinWidthSM: 28,
    trackMinWidth: 44,
    trackHeightSM: 16,
    trackHeight: 22,
    handleSizeSM: 12,
    handleSize: 18,
    marginXXS: 4,
    lineWidthFocus: 4,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeIcon: 12,
    fontSize: 14,
    controlHeight: 32,
    colorWhite: "#ffffff",
    colorTextTertiary: "rgba(0, 0, 0, 0.7)",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    handleBg: "#ffffff",
    fontFamily: "space grotesk",
  },
  TimePicker: {
    timeColumnWidth: 56,
    timeColumnHeight: 224,
    timeCellHeight: 28,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    sizePopupArrow: 16,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeLG: 16,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorWarning: "#faad14",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    hoverBorderColor: "#4439a3",
    cellHoverBg: "rgba(0, 0, 0, 0.04)",
    cellHeight: 24,
    activeBorderColor: "#0d058f",
    paddingInline: 11,
    paddingInlineLG: 11,
    paddingInlineSM: 7,
    activeBg: "#ffffff",
    hoverBg: "#ffffff",
    cellBgDisabled: "rgba(0, 0, 0, 0.04)",
    cellActiveWithRangeBg: "#eeedf6",
    cellHoverWithRangeBg: "#c8dfff",
    cellRangeBorderColor: "#7cb3ff",
    multipleItemBg: "#f6f4ff",
    multipleItemBorderColor: "rgba(0, 0, 0, 0)",
    multipleItemBorderColorDisabled: "rgba(0, 0, 0, 0)",
    multipleItemColorDisabled: "rgba(0, 0, 0, 0.22)",
    multipleSelectorBgDisabled: "rgba(0, 0, 0, 0.04)",
    cellWidth: 36,
    multipleItemHeight: 24,
    multipleItemHeightLG: 32,
    multipleItemHeightSM: 16,
    paddingBlock: 4,
    paddingBlockLG: 7,
    paddingBlockSM: 0,
    presetsMaxWidth: 200,
    presetsWidth: 120,
    textHeight: 40,
    withoutTimeCellHeight: 66,
    inputFontSize: 14,
    inputFontSizeLG: 16,
    inputFontSizeSM: 12,
    fontFamily: "space grotesk",
  },
  Timeline: {
    itemPaddingBottom: 20,
    paddingXXS: 4,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSize: 14,
    controlHeightLG: 40,
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorPrimary: "#0d058f",
    colorError: "#ff4d4f",
    colorBgContainer: "#ffffff",
    tailColor: "rgba(0, 0, 0, 0.06)",
    dotBg: "#ffffff",
    fontFamily: "space grotesk",
  },
  Tabs: {
    horizontalItemGutter: 32,
    cardGutter: 2,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimaryActive: "#08047d",
    colorPrimary: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorBorderSecondary: "#ebebeb",
    colorBorder: "#cdcaca",
    colorBgContainer: "#ffffff",
    itemSelectedColor: "#0d058f",
    itemHoverColor: "#4439a3",
    itemColor: "rgba(0, 0, 0, 0.88)",
    itemActiveColor: "#08047d",
    inkBarColor: "#0d058f",
    cardHeight: 40,
    cardBg: "rgba(0, 0, 0, 0.02)",
    titleFontSize: 14,
    titleFontSizeLG: 16,
    titleFontSizeSM: 14,
    fontFamily: "space grotesk",
  },
  Table: {
    stickyScrollBarBorderRadius: 100,
    headerSplitColor: "#ebebeb",
    headerBg: "#f7f4f1",
    footerBg: "rgba(0, 0, 0, 0.02)",
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    marginXXS: 4,
    margin: 16,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSizeIcon: 12,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActiveHover: "#e4e1ed",
    controlItemBgActive: "#eeedf6",
    controlInteractiveSize: 16,
    controlHeight: 32,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimary: "#0d058f",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillSecondary: "#f6f4ff",
    colorFillContent: "#f6f4ff",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorBorderSecondary: "#ebebeb",
    colorBgContainer: "#ffffff",
    rowSelectedHoverBg: "#e4e1ed",
    headerFilterHoverBg: "#f6f4ff",
    headerColor: "rgba(0, 0, 0, 0.88)",
    headerBorderRadius: 4,
    footerColor: "rgba(0, 0, 0, 0.88)",
    filterDropdownMenuBg: "#ffffff",
    filterDropdownBg: "#ffffff",
    cellPaddingInlineSM: 8,
    cellPaddingInlineMD: 8,
    cellPaddingInline: 16,
    cellPaddingBlockSM: 8,
    cellPaddingBlockMD: 12,
    cellPaddingBlock: 16,
    borderColor: "#ebebeb",
    rowHoverBg: "#ffffff",
    headerSortActiveBg: "#f6f4ff",
    bodySortBg: "#ffffff",
    headerSortHoverBg: "#f6f4ff",
    cellFontSize: 14,
    cellFontSizeMD: 14,
    cellFontSizeSM: 14,
    fontFamily: "space grotesk",
    cellwhiteBg: "#ffffff",
    cellgreyBg: "rgba(0, 0, 0, 0.02)",
  },
  Steps: {
    dotSize: 8,
    dotCurrentSize: 10,
    descriptionMaxWidth: 140,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    margin: 16,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeightSM: 1.6666666666666667,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSizeHeading3: 24,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#389e0d",
    controlHeightLG: 40,
    borderRadiusSM: 2,
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorTextLabel: "rgba(0, 0, 0, 0.65)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "#000000",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorFillContent: "#f7f4f1",
    colorError: "#ff4d4f",
    colorBorderSecondary: "#ebebeb",
    colorBorderBg: "#ffffff",
    colorBgContainer: "#ffffff",
    titleLineHeight: 32,
    iconSizeSM: 24,
    iconSize: 32,
    finishIconBorderColor: "#1677ff",
    customIconFontSize: 24,
    iconFontSize: 14,
    fontFamily: "space grotesk",
  },
  Spin: {
    dotSizeSM: 14,
    dotSize: 20,
    contentHeight: 400,
    marginXXS: 4,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeightLG: 40,
    controlHeight: 32,
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimary: "#0d058f",
    colorBgContainer: "#ffffff",
    dotSizeLG: 32,
    fontFamily: "space grotesk",
  },
  Slider: {
    railSize: 4,
    handleSizeHover: 12,
    dotSize: 8,
    controlSize: 10,
    handleSize: 10,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryBorderHover: "#655ab0",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorFillSecondary: "#f6f4ff",
    colorFillContentHover: "#f7f4f1",
    colorBorderSecondary: "#ebebeb",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    trackHoverBg: "#655ab0",
    trackBgDisabled: "rgba(0, 0, 0, 0.04)",
    trackBg: "#0d058f",
    railHoverBg: "#f6f4ff",
    railBg: "rgba(0, 0, 0, 0.04)",
    handleColor: "#0d058f",
    handleActiveColor: "#0d058f",
    dotBorderColor: "#08047d",
    dotActiveBorderColor: "#e4e1ed",
    handleColorDisabled: "#bfbfbf",
    fontFamily: "space grotesk",
  },
  Rate: {
    rateStarSize: 20,
    marginXS: 8,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeightLG: 40,
    colorText: "rgba(0, 0, 0, 0.88)",
    colorFillContent: "#f6f4ff",
    fontFamily: "space grotesk",
  },
  Radio: {
    radioSize: 16,
    dotSize: 8,
    buttonPaddingInline: 15,
    paddingXS: 8,
    padding: 16,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgActiveDisabled: "#f7f4f1",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWhite: "#ffffff",
    colorTextLightSolid: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimaryActive: "#08047d",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    wrapperMarginInlineEnd: 8,
    dotColorDisabled: "rgba(0, 0, 0, 0.22)",
    buttonSolidCheckedHoverBg: "#4439a3",
    buttonSolidCheckedColor: "#ffffff",
    buttonSolidCheckedBg: "#0d058f",
    buttonSolidCheckedActiveBg: "#08047d",
    buttonColor: "rgba(0, 0, 0, 0.88)",
    buttonCheckedColorDisabled: "rgba(0, 0, 0, 0.22)",
    buttonCheckedBgDisabled: "#f7f4f1",
    buttonCheckedBg: "#ffffff",
    buttonBg: "#ffffff",
    fontFamily: "space grotesk",
    radioBgColor: "#0d058f",
    radioColor: "#ffffff",
  },
  Popover: {
    titleMinWidth: 177,
    sizePopupArrow: 16,
    paddingSM: 12,
    padding: 16,
    marginXS: 8,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSize: 14,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusLG: 4,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorBgElevated: "#ffffff",
    fontFamily: "space grotesk",
  },
  Notification: {
    width: 384,
    paddingMD: 20,
    paddingLG: 24,
    paddingContentHorizontalLG: 24,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    margin: 16,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlHeightLG: 40,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorInfo: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorError: "#ff4d4f",
    colorBgElevated: "#ffffff",
    lineHeightLG: 1.5,
    lineWidthFocus: 4,
    fontFamily: "space grotesk",
  },
  Tooltip: {
    paddingSM: 12,
    sizePopupArrow: 16,
    paddingXS: 8,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadius: 4,
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorBgSpotlight: "rgba(0, 0, 0, 0.85)",
    fontFamily: "space grotesk",
  },
  Menu: {
    subMenuItemBg: "#f2ece6",
    darkSubMenuItemBg: "#000c17",
    darkItemDisabledColor: "rgba(255, 255, 255, 0.25)",
    darkItemColor: "rgba(255, 255, 255, 0.65)",
    darkGroupTitleColor: "rgba(255, 255, 255, 0.65)",
    darkItemBg: "#001529",
    paddingXS: 8,
    paddingXL: 32,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    margin: 16,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlItemBgActive: "#eeedf6",
    controlHeightSM: 24,
    controlHeightLG: 40,
    borderRadius: 4,
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorFillContent: "#f6f4ff",
    colorErrorHover: "#ff7875",
    colorErrorBg: "#fff2f0",
    colorError: "#ff4d4f",
    colorBgElevated: "#ffffff",
    colorBgContainer: "#ffffff",
    subMenuItemBorderRadius: 2,
    popupBg: "#ffffff",
    itemSelectedColor: "#08047d",
    itemSelectedBg: "#eeedf6",
    itemHoverColor: "rgba(0, 0, 0, 0.88)",
    itemHoverBg: "#eeedf6",
    itemHeight: 40,
    itemDisabledColor: "rgba(0, 0, 0, 0.22)",
    itemColor: "rgba(0, 0, 0, 0.88)",
    itemBorderRadius: 4,
    itemBg: "#f6f2ef",
    iconSize: 14,
    horizontalItemSelectedColor: "#0d058f",
    horizontalItemSelectedBg: "rgba(0, 0, 0, 0)",
    horizontalItemHoverColor: "#0d058f",
    horizontalItemHoverBg: "rgba(0, 0, 0, 0)",
    groupTitleColor: "rgba(0, 0, 0, 0.7)",
    darkItemSelectedColor: "#ffffff",
    darkItemSelectedBg: "#0d058f",
    darkItemHoverColor: "#ffffff",
    darkItemHoverBg: "rgba(0, 0, 0, 0)",
    collapsedIconSize: 16,
    darkPopupBg: "#001529",
    activeBarBorderWidth: 1,
    collapsedWidth: 80,
    dropdownWidth: 160,
    itemMarginBlock: 4,
    itemMarginInline: 4,
    iconMarginInlineEnd: 10,
    groupTitleFontSize: 14,
    groupTitleLineHeight: 1.5714285714285714,
    fontFamily: "space grotesk",
    itemfocusbg: "#e4e1ed",
  },
  InputNumber: {
    paddingInlineSM: 7,
    paddingInlineLG: 11,
    paddingInline: 11,
    paddingBlockSM: 0,
    paddingBlockLG: 7,
    paddingBlock: 4,
    handleWidth: 22,
    controlWidth: 90,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningBorderHover: "#ffd666",
    colorWarning: "#faad14",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimary: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorBorderHover: "#ffa39e",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    hoverBorderColor: "#4439a3",
    handleHoverColor: "#0d058f",
    handleBorderColor: "#cdcaca",
    handleBg: "#ffffff",
    handleActiveBg: "rgba(0, 0, 0, 0.02)",
    addonBg: "rgba(0, 0, 0, 0.02)",
    activeBorderColor: "#0d058f",
    activeBg: "#ffffff",
    hoverBg: "#ffffff",
    inputFontSize: 14,
    inputFontSizeLG: 16,
    inputFontSizeSM: 12,
    fontFamily: "space grotesk",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorFillSecondary: "#f6f4ff",
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorWarningBg: "#fff8d4",
    colorWarningBgHover: "#fff1b8",
    colorErrorBg: "#fff2f0",
    colorErrorBgHover: "#fff1f0",
    filledHandleBg: "#f0f0f0",
    colorErrorText: "#ff4d4f",
    colorWarningText: "#b05800",
  },
  Image: {
    previewOperationSize: 18,
    previewOperationHoverColor: "rgba(255, 255, 255, 0.85)",
    previewOperationColorDisabled: "rgba(255, 255, 255, 0.25)",
    previewOperationColor: "rgba(255, 255, 255, 0.65)",
    paddingXXS: 4,
    paddingSM: 12,
    paddingLG: 24,
    marginXXS: 4,
    marginXL: 32,
    marginSM: 12,
    margin: 16,
    fontSizeIcon: 12,
    controlHeightLG: 40,
    colorTextLightSolid: "#ffffff",
    colorBgMask: "rgba(0, 0, 0, 0.45)",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
  },
  Card: {
    headerHeightSM: 38,
    headerHeight: 56,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSize: 14,
    borderRadiusLG: 4,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimary: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorBorderSecondary: "#ebebeb",
    colorBgContainer: "#ffffff",
    headerBg: "rgba(0, 0, 0, 0)",
    headerFontSize: 16,
    headerFontSizeSM: 14,
    fontHeight: 22,
    fontSizeLG: 16,
    fontFamily: "space grotesk",
  },
  Carousel: {
    dotWidth: 16,
    dotHeight: 3,
    dotActiveWidth: 24,
    marginXXS: 4,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeightSM: 24,
    controlHeightLG: 40,
    colorText: "rgba(0, 0, 0, 0.88)",
    colorBgContainer: "#ffffff",
    fontFamily: "space grotesk",
  },
  Cascader: {
    dropdownHeight: 180,
    controlWidth: 184,
    controlItemWidth: 111,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlInteractiveSize: 16,
    controlHeight: 32,
    borderRadiusSM: 2,
    colorWhite: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    optionSelectedBg: "#eeedf6",
    menuPadding: 4,
    optionSelectedFontWeight: 600,
    fontFamily: "space grotesk",
  },
  Calendar: {
    yearControlWidth: 80,
    monthControlWidth: 70,
    controlHeight: 32,
    screenXS: 480,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeightSM: 1.6666666666666667,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlHeightSM: 24,
    controlHeightLG: 40,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimary: "#0d058f",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    itemActiveBg: "#eeedf6",
    fullPanelBg: "#ffffff",
    fullBg: "#ffffff",
    fontHeightSM: 20,
    fontFamily: "space grotesk",
  },
  Button: {
    paddingInlineSM: 7,
    paddingInlineLG: 15,
    paddingInline: 15,
    onlyIconSizeSM: 14,
    onlyIconSizeLG: 18,
    paddingXS: 8,
    paddingContentHorizontal: 16,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidth: 1,
    contentLineHeight: 1.5714285714285714,
    contentFontSizeLG: 16,
    contentFontSize: 14,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorTextLightSolid: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimaryActive: "#08047d",
    colorPrimary: "#0d058f",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorErrorHover: "#ff7875",
    colorErrorBorderHover: "#ffa39e",
    colorErrorBg: "#fff2f0",
    colorErrorActive: "#cf1322",
    colorError: "#d9363e",
    colorBorder: "#cdcaca",
    colorBgTextActive: "#f7f4f1",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    textHoverBg: "#f6f4ff",
    primaryColor: "#ffffff",
    onlyIconSize: 16,
    linkHoverBg: "rgba(0, 0, 0, 0)",
    groupBorderColor: "#4439a3",
    ghostBg: "rgba(0, 0, 0, 0)",
    defaultGhostColor: "#ffffff",
    defaultGhostBorderColor: "#ffffff",
    defaultColor: "rgba(0, 0, 0, 0.88)",
    defaultBorderColor: "#cdcaca",
    defaultBg: "#ffffff",
    dangerColor: "#ffffff",
    borderColorDisabled: "#cdcaca",
    defaultHoverBg: "#ffffff",
    defaultHoverColor: "#4439a3",
    defaultHoverBorderColor: "#4439a3",
    defaultActiveBg: "#ffffff",
    defaultActiveColor: "#08047d",
    defaultActiveBorderColor: "#08047d",
    fontWeight: 400,
    contentFontSizeSM: 14,
    contentLineHeightLG: 1.5,
    contentLineHeightSM: 1.5714285714285714,
  },
  Badge: {
    statusSize: 6,
    indicatorHeight: 20,
    dotSize: 6,
    paddingXS: 8,
    marginXS: 8,
    lineWidth: 1,
    borderRadiusSM: 2,
    fontSizeSM: 12,
    fontSize: 14,
    colorWarning: "#faad14",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorPrimary: "#0d058f",
    colorErrorHover: "#ff7875",
    colorError: "#ff4d4f",
    colorBorderBg: "#ffffff",
    colorBgContainer: "#ffffff",
    indicatorHeightSM: 14,
    textFontSize: 12,
    textFontSizeSM: 12,
    fontHeight: 22,
    lineHeight: 1.5714285714285714,
    fontFamily: "space grotesk",
  },
  Form: {
    screenXSMax: 575,
    screenSMMax: 767,
    screenMDMax: 991,
    screenLGMax: 1199,
    paddingXS: 8,
    paddingSM: 12,
    marginXXS: 4,
    marginXS: 8,
    marginLG: 24,
    margin: 16,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorPrimary: "#0d058f",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    labelRequiredMarkColor: "#ff4d4f",
    labelColor: "rgba(0, 0, 0, 0.88)",
    itemMarginBottom: 24,
    labelColonMarginInlineEnd: 8,
    labelColonMarginInlineStart: 2,
    labelHeight: 32,
    labelFontSize: 14,
    fontFamily: "space grotesk",
  },
  Avatar: {
    marginXXS: 4,
    marginXS: 8,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeXL: 20,
    fontSizeLG: 16,
    fontSizeHeading3: 24,
    fontSize: 14,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorBorderBg: "#ffffff",
    containerSizeSM: 24,
    containerSizeLG: 40,
    containerSize: 32,
    textFontSize: 18,
    textFontSizeLG: 24,
    textFontSizeSM: 14,
    fontFamily: "space grotesk",
  },
  Tour: {
    sizePopupArrow: 16,
    paddingXS: 8,
    padding: 16,
    marginXS: 8,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSize: 14,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWhite: "#ffffff",
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimary: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFill: "#f7f4f1",
    colorBgTextHover: "#f6f4ff",
    colorBgElevated: "#ffffff",
    closeBtnSize: 22,
    primaryNextBtnHoverBg: "#f0f0f0",
    primaryPrevBtnBg: "rgba(255, 255, 255, 0.15)",
    fontFamily: "space grotesk",
    lineWidthFocus: 4,
  },
  QRCode: {
    paddingSM: 12,
    marginXS: 8,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSize: 14,
    controlHeight: 32,
    borderRadiusLG: 4,
    colorWhite: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    fontFamily: "space grotesk",
  },
  Upload: {
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    marginXL: 32,
    margin: 16,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSizeHeading3: 24,
    fontSizeHeading2: 30,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlHeightLG: 40,
    borderRadiusLG: 4,
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimary: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorBg: "#fff2f0",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgMask: "rgba(0, 0, 0, 0.45)",
    fontHeight: 22,
    fontHeightSM: 20,
    lineWidthFocus: 4,
    fontFamily: "space grotesk",
  },
  Typography: {
    paddingSM: 12,
    marginXXS: 4,
    marginXS: 8,
    lineWidth: 1,
    lineHeightHeading5: 1.5,
    lineHeightHeading4: 1.4,
    lineHeightHeading3: 1.3333333333333333,
    lineHeightHeading2: 1.2666666666666666,
    lineHeightHeading1: 1.2105263157894737,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeHeading5: 16,
    fontSizeHeading4: 20,
    fontSizeHeading3: 24,
    fontSizeHeading2: 30,
    fontSizeHeading1: 38,
    fontSize: 14,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorErrorHover: "#ff7875",
    colorErrorActive: "#d9363e",
    colorError: "#ff4d4f",
    fontFamilyCode: "SPace grotesk",
  },
  TreeSelect: {
    paddingXS: 8,
    marginXXS: 4,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlInteractiveSize: 16,
    controlHeightSM: 24,
    borderRadiusSM: 2,
    borderRadius: 4,
    colorWhite: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    titleHeight: 24,
    nodeSelectedBg: "#eeedf6",
    nodeHoverBg: "rgba(0, 0, 0, 0.04)",
    fontFamily: "space grotesk",
  },
  Tree: {
    paddingSM: 12,
    borderRadiusLG: 4,
    paddingXS: 8,
    marginXXS: 4,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlInteractiveSize: 16,
    controlHeightSM: 24,
    borderRadiusSM: 2,
    borderRadius: 4,
    colorWhite: "#ffffff",
    colorTextLightSolid: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    titleHeight: 24,
    nodeSelectedBg: "#eeedf6",
    nodeHoverBg: "rgba(0, 0, 0, 0.04)",
    directoryNodeSelectedColor: "#ffffff",
    directoryNodeSelectedBg: "#0d058f",
    fontFamily: "space grotesk",
  },
  Tag: {
    paddingXXS: 4,
    marginXS: 8,
    lineWidth: 1,
    lineHeightSM: 1.6666666666666667,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeIcon: 12,
    fontSize: 14,
    borderRadiusSM: 2,
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryActive: "#08047d",
    colorPrimary: "#0d058f",
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorFillSecondary: "#f6f4ff",
    colorFillQuaternary: "rgba(0, 0, 0, 0.02)",
    colorBorder: "#cdcaca",
    colorWarningBorder: "#ffe58f",
    colorWarningBg: "#fff8d4",
    colorSuccessBorder: "#b7eb8f",
    colorSuccessBg: "#f0ffe1",
    colorInfoBorder: "#e4e1ed",
    colorInfoBg: "#eeedf6",
    colorErrorBorder: "#ffccc7",
    colorErrorBg: "#fff2f0",
    defaultColor: "rgba(0, 0, 0, 0.88)",
    defaultBg: "rgba(0, 0, 0, 0.02)",
    fontFamily: "space grotesk",
  },
  Statistic: {
    padding: 16,
    marginXXS: 4,
    lineHeight: 1.5714285714285714,
    fontSizeHeading3: 24,
    fontSize: 14,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    contentFontSize: 24,
    titleFontSize: 14,
    fontFamily: "space grotesk",
  },
  Skeleton: {
    padding: 16,
    marginXXS: 4,
    marginSM: 12,
    marginLG: 24,
    controlHeightXS: 16,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    colorFillContent: "#f6f4ff",
    colorFill: "#f7f4f1",
  },
  Select: {
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlHeightXS: 16,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorWarningHover: "#ffd666",
    colorTextTertiary: "rgba(0, 0, 0, 0.7)",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimary: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillSecondary: "#f6f4ff",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorErrorHover: "#ff7875",
    colorBorder: "#cdcaca",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    singleItemHeightLG: 40,
    selectorBg: "#ffffff",
    optionSelectedColor: "rgba(0, 0, 0, 0.88)",
    optionSelectedBg: "#e4e1ed",
    optionLineHeight: null,
    optionHeight: 32,
    optionActiveBg: "rgba(0, 0, 0, 0.04)",
    multipleSelectorBgDisabled: "rgba(0, 0, 0, 0.04)",
    multipleItemHeightLG: 32,
    multipleItemHeight: 24,
    multipleItemColorDisabled: "rgba(0, 0, 0, 0.22)",
    multipleItemBorderColorDisabled: "rgba(0, 0, 0, 0)",
    multipleItemBorderColor: "rgba(0, 0, 0, 0)",
    multipleItemBg: "#f6f4ff",
    clearBg: "#ffffff",
    optionFontSize: "space grotesk",
    optionSelectedFontWeight: 600,
    fontFamily: "space grotesk",
    showArrowPaddingInlineEnd: 18,
  },
  Result: {
    paddingXS: 8,
    paddingXL: 32,
    paddingLG: 24,
    padding: 16,
    marginXS: 8,
    lineHeightHeading3: 1.3333333333333333,
    lineHeight: 1.5714285714285714,
    fontSizeHeading3: 24,
    fontSize: 14,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorSuccess: "#52c41a",
    colorInfo: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorError: "#ff4d4f",
    iconFontSize: 72,
    subtitleFontSize: 14,
    titleFontSize: 24,
  },
  Progress: {
    paddingXS: 8,
    marginXXS: 4,
    marginXS: 8,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSize: 14,
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorFillSecondary: "#f6f4ff",
    colorError: "#ff4d4f",
    colorBgContainer: "#ffffff",
    remainingColor: "#f6f4ff",
    defaultColor: "#0d058f",
    circleTextColor: "rgba(0, 0, 0, 0.88)",
    fontFamily: "space grotesk",
  },
  Popconfirm: {
    marginXXS: 4,
    marginXS: 8,
    fontWeightStrong: 600,
    fontSize: 14,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
  },
  Pagination: {
    screenSM: 576,
    screenLG: 992,
    paddingXXS: 4,
    paddingSM: 12,
    marginXXS: 4,
    marginXS: 8,
    marginSM: 12,
    margin: 16,
    lineWidthFocus: 4,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgActiveDisabled: "#f7f4f1",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorBorder: "#cdcaca",
    colorBgTextHover: "#f6f4ff",
    colorBgTextActive: "#f7f4f1",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    itemSizeSM: 24,
    itemSize: 32,
    itemLinkBg: "#ffffff",
    itemInputBg: "#ffffff",
    itemBg: "#ffffff",
    itemActiveColorDisabled: "rgba(0, 0, 0, 0.22)",
    itemActiveBgDisabled: "#f7f4f1",
    itemActiveBg: "#ffffff",
    fontFamily: "space grotesk",
  },
  Modal: {
    screenSMMax: 767,
    paddingXS: 8,
    paddingMD: 20,
    paddingLG: 24,
    paddingContentHorizontalLG: 24,
    padding: 16,
    marginXS: 8,
    marginSM: 12,
    marginLG: 24,
    margin: 16,
    lineWidthFocus: 4,
    lineWidth: 1,
    lineHeightHeading5: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeLG: 16,
    fontSizeHeading5: 16,
    fontSize: 14,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorPrimaryBorder: "#e4e1ed",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorBgMask: "rgba(0, 0, 0, 0.45)",
    titleColor: "rgba(0, 0, 0, 0.88)",
    headerBg: "#ffffff",
    footerBg: "rgba(0, 0, 0, 0)",
    contentBg: "#ffffff",
    titleFontSize: 16,
    titleLineHeight: 1.375,
    fontHeight: 22,
    fontFamily: "space grotesk",
  },
  Message: {
    paddingXS: 8,
    paddingSM: 12,
    marginXS: 8,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlHeightLG: 40,
    borderRadiusLG: 4,
    colorWarning: "#faad14",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccess: "#52c41a",
    colorInfo: "#0d058f",
    colorError: "#ff4d4f",
    contentBg: "#ffffff",
    fontFamily: "space grotesk",
  },
  List: {
    screenSM: 576,
    screenMD: 768,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    paddingContentVerticalSM: 8,
    paddingContentVerticalLG: 16,
    paddingContentVertical: 12,
    paddingContentHorizontalLG: 24,
    paddingContentHorizontal: 16,
    padding: 16,
    marginXXS: 4,
    marginXXL: 48,
    marginSM: 12,
    marginLG: 24,
    margin: 16,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSize: 14,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusLG: 4,
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    headerBg: "#f2ece6",
    footerBg: "rgba(0, 0, 0, 0)",
    avatarMarginRight: 16,
    descriptionFontSize: 14,
    fontFamily: "space grotesk",
  },
  FloatButton: {
    paddingXXS: 4,
    marginXXL: 48,
    marginLG: 24,
    margin: 16,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSize: 14,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlHeightLG: 40,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    colorTextLightSolid: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryHover: "#4439a3",
    colorPrimary: "#0d058f",
    colorFillContent: "#f6f4ff",
    colorBgElevated: "#ffffff",
    fontFamily: "space grotesk",
  },
  Empty: {
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    fontSize: 14,
    lineHeight: 1.5714285714285714,
  },
  Dropdown: {
    sizePopupArrow: 16,
    paddingXXS: 4,
    paddingXS: 8,
    marginXXS: 4,
    marginXS: 8,
    lineWidthFocus: 4,
    lineHeight: 1.5714285714285714,
    fontSizeSM: 12,
    fontSizeIcon: 12,
    fontSize: 14,
    controlPaddingHorizontal: 12,
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActiveHover: "#e4e1ed",
    controlItemBgActive: "#eeedf6",
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    colorTextLightSolid: "#08047d",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorError: "#ff4d4f",
    colorBgElevated: "#ffffff",
    paddingBlock: 5,
    fontFamily: "space grotesk",
  },
  Drawer: {
    paddingXS: 8,
    paddingLG: 24,
    padding: 16,
    marginSM: 12,
    lineWidth: 1,
    lineHeightLG: 1.5,
    fontWeightStrong: 600,
    fontSizeLG: 16,
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorBgMask: "rgba(0, 0, 0, 0.45)",
    colorBgElevated: "#ffffff",
    lineWidthFocus: 4,
  },
  Divider: {
    marginXS: 8,
    marginLG: 24,
    margin: 16,
    lineWidth: 1,
    fontSizeLG: 16,
    fontSize: 14,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    lineHeight: 1.5714285714285714,
    fontFamily: "space grotesk",
  },
  Descriptions: {
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    lineWidth: 1,
    lineHeightSM: 1.6666666666666667,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeSM: 12,
    fontSizeLG: 16,
    fontSize: 14,
    borderRadiusLG: 4,
    colorTextTertiary: "rgba(0, 0, 0, 0.7)",
    colorTextSecondary: "rgba(0, 0, 0, 0.65)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    titleColor: "rgba(0, 0, 0, 0.88)",
    labelBg: "rgba(0, 0, 0, 0.02)",
    contentColor: "rgba(0, 0, 0, 0.88)",
    fontFamily: "space grotesk",
  },
  DatePicker: {
    sizePopupArrow: 16,
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    padding: 16,
    marginXXS: 4,
    marginXS: 8,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeightLG: 1.5,
    lineHeight: 1.5714285714285714,
    fontWeightStrong: 600,
    fontSizeLG: 16,
    fontSize: 14,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorWarningHover: "#ffd666",
    colorWarning: "#faad14",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextLightSolid: "#ffffff",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorLinkHover: "#4439a3",
    colorLinkActive: "#08047d",
    colorLink: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorErrorHover: "#ff7875",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    hoverBorderColor: "#4439a3",
    cellHoverBg: "rgba(0, 0, 0, 0.04)",
    cellHeight: 24,
    activeBorderColor: "#0d058f",
    paddingInline: 11,
    paddingInlineSM: 7,
    colorFillTertiary: "rgba(0, 0, 0, 0.04)",
    colorErrorBg: "#fff2f0",
    colorWarningBg: "#fff8d4",
    colorWarningText: "#b05800",
    colorErrorText: "#ff4d4f",
    colorWarningBgHover: "#fff1b8",
    colorErrorBgHover: "#fff1f0",
    activeBg: "#ffffff",
    hoverBg: "#ffffff",
    cellBgDisabled: "rgba(0, 0, 0, 0.04)",
    cellActiveWithRangeBg: "#eeedf6",
    cellHoverWithRangeBg: "#c8dfff",
    cellRangeBorderColor: "#7cb3ff",
    multipleItemBg: "#f6f4ff",
    multipleItemBorderColor: "rgba(0, 0, 0, 0)",
    multipleItemBorderColorDisabled: "rgba(0, 0, 0, 0)",
    multipleItemColorDisabled: "rgba(0, 0, 0, 0.22)",
    multipleSelectorBgDisabled: "rgba(0, 0, 0, 0.04)",
    cellWidth: 36,
    multipleItemHeight: 24,
    multipleItemHeightLG: 32,
    multipleItemHeightSM: 16,
    paddingBlock: 4,
    paddingBlockLG: 7,
    paddingBlockSM: 0,
    "paddingInline 2": 11,
    presetsMaxWidth: 200,
    presetsWidth: 120,
    textHeight: 40,
    timeCellHeight: 28,
    timeColumnHeight: 224,
    timeColumnWidth: 56,
    withoutTimeCellHeight: 66,
    inputFontSize: 14,
    inputFontSizeLG: 16,
    inputFontSizeSM: 12,
    fontHeight: 22,
    fontHeightLG: 24,
    fontFamily: "space grotesk",
  },
  Collapse: {
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    paddingLG: 24,
    padding: 16,
    marginSM: 12,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSize: 14,
    borderRadiusLG: 4,
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorFillAlter: "rgba(0, 0, 0, 0.02)",
    colorBorder: "#cdcaca",
    colorBgContainer: "#ffffff",
    headerBg: "rgba(0, 0, 0, 0.02)",
    contentBg: "#ffffff",
    fontHeight: 22,
    fontHeightLG: 24,
    lineHeightLG: 1.5,
    fontFamily: "space grotesk",
  },
  Checkbox: {
    paddingXS: 8,
    marginXS: 8,
    lineWidthFocus: 4,
    lineWidthBold: 2,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    controlInteractiveSize: 16,
    borderRadiusSM: 2,
    colorWhite: "#ffffff",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimaryBorder: "#e4e1ed",
    colorPrimary: "#0d058f",
    colorBorder: "#cdcaca",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    fontFamily: "space grotesk",
  },
  Breadcrumb: {
    paddingXXS: 4,
    marginXXS: 4,
    marginXS: 8,
    lineWidthFocus: 4,
    lineHeight: 1.5714285714285714,
    fontSizeIcon: 12,
    fontSize: 14,
    borderRadiusSM: 2,
    colorPrimaryBorder: "#e4e1ed",
    colorBgTextHover: "#f6f4ff",
    separatorColor: "rgba(0, 0, 0, 0.7)",
    linkHoverColor: "rgba(0, 0, 0, 0.88)",
    linkColor: "rgba(0, 0, 0, 0.7)",
    lastItemColor: "rgba(0, 0, 0, 0.88)",
    itemColor: "rgba(0, 0, 0, 0.7)",
    separatorMargin: 8,
    iconFontSize: 14,
    fontHeight: 22,
    fontFamily: "space grotesk",
  },
  Anchor: {
    paddingXXS: 4,
    lineWidthBold: 2,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSize: 14,
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSplit: "rgba(0, 0, 0, 0.06)",
    colorPrimary: "#0d058f",
    linkPaddingInlineStart: 16,
    linkPaddingBlock: 4,
    fontFamily: "space grotesk",
  },
  Alert: {
    paddingMD: 20,
    paddingContentVerticalSM: 8,
    paddingContentHorizontalLG: 24,
    marginXS: 8,
    marginSM: 12,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    fontSizeLG: 16,
    fontSizeIcon: 12,
    fontSizeHeading3: 24,
    fontSize: 14,
    borderRadiusLG: 4,
    colorWarningBorder: "#ffe58f",
    colorWarningBg: "#fff8d4",
    colorWarning: "#faad14",
    colorTextHeading: "rgba(0, 0, 0, 0.88)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorSuccessBorder: "#b7eb8f",
    colorSuccessBg: "#f0ffe1",
    colorSuccess: "#52c41a",
    colorInfoBorder: "#e4e1ed",
    colorInfoBg: "#eeedf6",
    colorInfo: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorErrorBorder: "#ffccc7",
    colorErrorBg: "#fff2f0",
    colorError: "#ff4d4f",
    withDescriptionIconSize: 24,
    fontFamily: "space grotesk",
  },
  Space: {
    paddingXS: 8,
    paddingLG: 24,
    padding: 16,
  },
  AutoComplete: {
    paddingXXS: 4,
    paddingXS: 8,
    paddingSM: 12,
    lineWidth: 1,
    lineHeight: 1.5714285714285714,
    controlPaddingHorizontalSM: 8,
    controlPaddingHorizontal: 12,
    controlOutlineWidth: 2,
    controlOutline: "#08047d",
    controlItemBgHover: "rgba(0, 0, 0, 0.04)",
    controlItemBgActive: "#eeedf6",
    controlHeightXS: 16,
    controlHeightSM: 24,
    controlHeightLG: 40,
    controlHeight: 32,
    borderRadiusXS: 0,
    borderRadiusSM: 2,
    borderRadiusLG: 4,
    borderRadius: 4,
    colorWarningOutline: "rgba(255, 215, 5, 0.1)",
    colorWarningHover: "#ffd666",
    colorWarning: "#faad14",
    colorTextTertiary: "rgba(0, 0, 0, 0.7)",
    colorTextQuaternary: "rgba(0, 0, 0, 0.22)",
    colorTextPlaceholder: "rgba(0, 0, 0, 0.22)",
    colorTextDisabled: "rgba(0, 0, 0, 0.22)",
    colorTextDescription: "rgba(0, 0, 0, 0.7)",
    colorText: "rgba(0, 0, 0, 0.88)",
    colorPrimaryHover: "#4439a3",
    colorPrimary: "#0d058f",
    colorIconHover: "rgba(0, 0, 0, 0.88)",
    colorIcon: "rgba(0, 0, 0, 0.65)",
    colorFillSecondary: "#f6f4ff",
    colorErrorOutline: "rgba(255, 38, 6, 0.06)",
    colorErrorHover: "#ff7875",
    colorError: "#ff4d4f",
    colorBorder: "#cdcaca",
    colorBgElevated: "#ffffff",
    colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
    colorBgContainer: "#ffffff",
    optionActiveBg: "rgba(0, 0, 0, 0.04)",
    optionHeight: 32,
    optionFontSize: 14,
    fontFamily: "space grotesk",
    fontSize: 14,
    fontSizeIcon: 12,
    fontSizeLG: 16,
    fontSizeSM: 12,
  },
  Layout: {
    bodyBg: "#f2ece6",
    footerBg: "#f2ece6",
    headerBg: "#001529",
    headerColor: "rgba(0, 0, 0, 0.88)",
    lightSiderBg: "#ffffff",
    lightTriggerBg: "#ffffff",
    lightTriggerColor: "rgba(0, 0, 0, 0.88)",
    siderBg: "#001529",
    triggerBg: "#002140",
    triggerColor: "#ffffff",
    colorText: "rgba(0, 0, 0, 0.88)",
    headerHeight: 64,
    triggerHeight: 48,
    zeroTriggerHeight: 40,
    zeroTriggerWidth: 40,
    borderRadius: 4,
    fontSize: 14,
    fontSizeXL: 20,
  },
  Mentions: {
    fontFamily: "space grotesk",
    fontSize: 14,
    lineHeight: 1.5714285714285714,
  },
} as const;
